import { render, staticRenderFns } from "./ReviewMatchTransaction.vue?vue&type=template&id=52daf03e&"
import script from "./ReviewMatchTransaction.vue?vue&type=script&lang=js&"
export * from "./ReviewMatchTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMatchTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports